<template>
	<!-- star -->

	<div class="aboutUs_wrap">
		<nav2></nav2>
		<!-- 面包屑 -->
		<!--<div class="Crumbs">-->
			<!--<div>当前位置：产品案例><span>信息采集平台</span></div>-->
		<!--</div>-->
		<!--<div class="navWrap_center_img">-->
		<banner2 :bannerH="h1" :bannerImg="Img1"></banner2>
		<!--</div>-->
		<div class="middle">
			<h1>团队介绍</h1>
			<b class="watermark">ABOUT TEAM</b>
			<img src="../assets/img/aboutUs/us/CEO.png" alt="" />
			<img src="../assets/img/aboutUs/us/CTO.png" alt="" />
			<img src="../assets/img/aboutUs/us/PM.png" alt="" />
		</div>
		<!--<div class="container">-->
			<!--&lt;!&ndash;<h1>团队介绍</h1>&ndash;&gt;-->
			<!--&lt;!&ndash;<b class="watermark1">ABOUT TEAM</b>&ndash;&gt;-->
		<!--<div class="grid-container">-->
				<!--<div class="grid-item">-->
					<!--<div><img src="../assets/img/aboutUs/us/CTO.png" alt="" /></div>-->
				<!--</div>-->
				<!--<div class="grid-item">-->
					<!--<div><img src="../assets/img/aboutUs/us/PM.png" alt="" /></div>-->
				<!--</div>-->
		<!--</div>-->

		<!--</div>-->



		<!-- footer -->
		<footer2></footer2>
		<!-- end -->
	</div>
</template>

<script>
import footer2 from "../components/footer.vue";
import banner2 from "../components/banner.vue";
import nav2 from "../components/nav.vue";
export default {
	name: "team",
	components: {
		footer2,
		nav2,
		banner2,
	},
	data() {
		return {
			// h1: "集团产业 · 集团产业",
			Img1: require("../assets/img/aboutUs/aboutUsBanner.png"),
			arrList: [
				{
					url: require("../assets/img/infoc/产品优势_实时处理和流式计算.png"),
				},
				{
					url: require("../assets/img/infoc/产品优势_安全性和合规性.png"),
				},
				{
					url: require("../assets/img/infoc/产品优势_多源数据集成.png"),
				},
				{
					url: require("../assets/img/infoc/产品优势_可扩展性和灵活性.png"),
				},
			],
			logoList: [
				{ logo: require("../assets/img/aboutUs/partner/c1.png") },
				{ logo: require("../assets/img/aboutUs/partner/c2.png") },
				{ logo: require("../assets/img/aboutUs/partner/c3.png") },
				{ logo: require("../assets/img/aboutUs/partner/c4.png") },
				{ logo: require("../assets/img/aboutUs/partner/c5.png") },
				{ logo: require("../assets/img/aboutUs/partner/c6.png") },
				{ logo: require("../assets/img/aboutUs/partner/c7.png") },
			],
		};
	},
	methods: {},
};
</script>
<style scoped>
@charset "utf-8";
/*=========================Reset_start==========================*/
body,
h1,
h2,
h3,
h4,
h5,
h6,
div,
p,
dl,
dt,
dd,
ol,
ul,
li,
form,
table,
th,
td,
a,
img,
span,
strong,
var,
em,
input,
textarea,
select,
option {
	margin: 0;
	padding: 0;
}
/*去内外边距*/
html,
body {
	font-family: "微软雅黑", "宋体", Arail, Tabhoma;
	text-align: left;
}
/*字体 文本居左*/
ul {
	list-style: none;
}
/*去ul li 小点*/
img {
	border: 0 none;
}
/*img IE6 兼容问题*/
input,
select,
textarea {
	outline: 0;
}
/*去除点击蓝框*/
textarea {
	resize: none;
	overflow: auto;
}
/*锁定多行文本框大小 与文字超出出现滚动条*/
table {
	border-collapse: collapse;
	border-spacing: 0;
}
/*表格边框合并 边框间距0*/
th,
strong,
var,
em {
	font-weight: normal;
	font-style: normal;
}
/*特殊文字粗细 样式显示正常*/
a {
	text-decoration: none;
}
/*a标签去下划线*/
.clearfix:after {
	clear: both;
	content: "";
	display: block;
	height: 0;
}
/*清浮动*/
a {
	color: #000000;
}
/*==========================Reset_End===========================*/
.watermark {
	position: relative;
	/*bottom: 10px;*/
	/*right: 10px;*/
	margin-top: -250px;
	text-align: center;
	color: #EAEEFC;
	font-size: 80px;
	font-family:AlibabaPuHuiTi-3-55-Regular;
	opacity: 0.5;
	top:120px;
	z-index: 1;
}
.title{
	position: relative;
	text-align: center;
	font-family: AlibabaPuHuiTi-3-55-Regular;
	margin-top:-50px;
	margin-bottom: 80px;
	z-index: 3
}
.watermark {
	position: relative;
	/*bottom: 10px;*/
	/*right: 10px;*/
	margin-top: -250px;
	text-align: center;
	color: #EAEEFC;
	font-size: 80px;
	font-family:AlibabaPuHuiTi-3-55-Regular;
	opacity: 0.5;
	top:120px;
	z-index: 1;
}
.title{
	position: relative;
	text-align: center;
	font-family: AlibabaPuHuiTi-3-55-Regular;
	margin-top:-50px;
	margin-bottom: 80px;
	z-index: 3
}
.container {
	position:relative;
	display: grid;
	background-color: #F8F9FC;
	width: 1920px;
	height: auto;
	/*margin:0 auto;*/
}
@media screen and (max-device-width: 1900px) {
	.container {
		height: auto;
		width: 1680px;
	}
}
@media screen and (max-device-width: 1500px) {
	.container {
		height: auto;
		width: 1440px;
	}
}
@media screen and (max-device-width: 1400px) {
	.container {
		height: auto;
		width: 1366px;
	}
}
@media screen and (max-device-width: 1300px) {
	.container {
		height: auto;
		width: 1280px;
	}
}
@media screen and (min-device-width: 2000px) {
	.container {
		height: auto;
		width: 2560px;
	}
}
.container img{
	width: 516px;
	height: auto;
	margin:0 auto;
	display: flex;
	justify-content: space-between;

}
.container h1 {
	font-size: 40px;
	font-family:AlibabaPuHuiTi-3-55-Regular;
	font-weight: 600;
	color: #444444;
	/*background-color: #F8F9FC;*/
	line-height: 45px;
	text-align: center;
	top: revert;
	margin-top: 200px;
	margin-bottom: 80px;
	position: relative;
	z-index: 2;
	/*font-size: 32px;*/
	/*font-family:AlibabaPuHuiTi-3-55-Regular;*/
	/*font-weight: 500;*/
	/*color: #444444;*/
	/*background-color: #F8F9FC;*/
	/*line-height: 45px;*/
	/*text-align: center;*/
	/*top: revert;*/
	/*margin-top: 200px;*/
	/*margin-bottom: 80px;*/
}
.grid-container {
	display: flex;
	width: 100%;
	justify-content: center;
	/*text-align:-moz-center;*/
	background-color: #F8F9FC;
	/*grid-template-columns: repeat(2, 1fr);*/
	/*grid-template-rows: repeat(2, 0.5fr);*/
}
.grid-item {
	/*text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);*/
	background-color: #F8F9FC;
	color: #fff;
	/*width: 314px;*/
	/*justify-content: center;*/
	/*text-align: center;*/
	/*padding: 30px 80px;*/
}

.middle{
	position:relative;
	display: grid;
	background: #F8F9FC;
	width: 1920px;
	/*margin:0 auto;*/
	/*text-align: center;*/
	justify-content: center;
	/*grid-template-rows: repeat(2, 0.5fr);*/
	/*grid-template-columns: repeat(1, 1fr);*/
	/*margin-bottom:20px;*/
}
@media screen and (max-device-width: 1900px) {
	.middle {
		height: auto;
		width: 1680px;
	}
}
@media screen and (max-device-width: 1500px) {
	.middle {
		height: auto;
		width: 1440px;
	}
}
@media screen and (max-device-width: 1400px) {
	.middle {
		height: auto;
		width: 1366px;
	}
}
@media screen and (max-device-width: 1300px) {
	.middle {
		height: auto;
		width: 1280px;
	}
}
@media screen and (min-device-width: 2000px) {
	.middle {
		height: auto;
		width: 2560px;
	}
}
.middle img{
	width: 1036px;
	/*height: auto;*/
	/*margin:0 auto;*/
	display: flex;
	justify-content: space-between;

}
.middle h1 {
	font-size: 40px;
	font-family:AlibabaPuHuiTi-3-55-Regular;
	font-weight: 600;
	color: #444444;
	/*background-color: #F8F9FC;*/
	line-height: 45px;
	text-align: center;
	top: revert;
	margin-top: 200px;
	margin-bottom: 80px;
	position: relative;
	z-index: 2;
}
.middle p{
	/*margin-top: 250px;*/
	width: 1100px;
	font-size: 16px;
	font-family: AlibabaPuHuiTi-3-55-Regular;
	font-weight: 400;
	/*text-align: center;*/
	/*color: #ffffff;*/
	line-height: 40px;
}


.middle1{
	position:relative;
	display: grid;
	background: #F8F9FC;
	width: 1920px;
	/*margin:0 auto;*/
	/*text-align: center;*/
	justify-content: center;
	/*grid-template-rows: repeat(2, 0.5fr);*/
	/*grid-template-columns: repeat(1, 1fr);*/
	/*margin-bottom:20px;*/

}
.middle1 h1 {
	font-size: 40px;
	font-family:AlibabaPuHuiTi-3-55-Regular;
	font-weight: 600;
	color: #444444;
	/*background-color: #F8F9FC;*/
	line-height: 45px;
	text-align: center;
	top: revert;
	margin-top: 200px;
	margin-bottom: 80px;
	position: relative;
	z-index: 2;
}
.middle1 img{
	width: 1100px;
	/*height: auto;*/
	/*margin:0 auto;*/
	display: flex;
	justify-content: space-between;

}
.aboutUs_wrap {
	width: 100%;
	margin: 0 auto;
	height: auto;
	/*background-position: right bottom, left top;*/
}
.CooperativePartner {
	/*width: 100vw;*/
	/*height: 798px;*/
	width: 1920px;
	height: auto;
	background-image: url("../assets/img/aboutUs/partner/cback.png");
}
.CooperativePartner_cont {
	width: 1200px;
	margin: 0 auto;
}
.CooperativePartner_cont_title {
	font-size: 40px;
	font-family:AlibabaPuHuiTi-3-55-Regular;
	font-weight: 600;
	color: #444444;
	/*background-color: #F8F9FC;*/
	line-height: 45px;
	text-align: center;
	top: revert;
	margin-top: 200px;
	margin-bottom: 80px;
	position: relative;
	z-index: 2;
}
.CooperativePartner_cont_center {
	display: flex;
	justify-content: space-between;
	width: 365px;
	height: 69px;

	margin: 0 auto;
	margin-top: 47px;
}
.CooperativePartner_cont_center_item {
	display: flex;
	align-items: center;
}
.CooperativePartner_cont_center_item:hover {
	border-bottom: 1px solid #3491e5;
}
.CooperativePartner_cont_center_item img {
	width: 40px;
	height: 40px;
}
.CooperativePartner_cont_center_item span {
	line-height: 69px;
	font-size: 24px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #23337f;
	line-height: 33px;
	margin-left: 14px;
}
.CooperativePartner_cont_bottom {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	width: 1400px;
	height: 392px;
	margin: 0 auto;
	margin-top: 80px;
}
.CooperativePartner_cont_bottom_logo img {
	width: 196px;
	height: auto;
	background: #ffffff;
	box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.12);
	border-radius: 9px;
	margin-bottom: 16px;
}
</style>
